import "../../FhSpinner.css";
import { computed, openBlock, createElementBlock, createVNode, withCtx, renderSlot, Fragment, createTextVNode, createElementVNode, normalizeClass } from "vue";
import { SIZES_ENUMS, VARIANTS_ENUMS } from "./constants.mjs";
import FhVisuallyHidden from "../FhVisuallyHidden/FhVisuallyHidden.mjs";
import { _ as _export_sfc } from "../../_plugin-vue_export-helper-1tPrXgE0.js";
const _hoisted_1 = {
  role: "status",
  "aria-live": "polite",
  class: "fh-spinner"
};
const _sfc_main = {
  __name: "FhSpinner",
  props: {
    size: {
      type: String,
      default: SIZES_ENUMS.MD,
      validator: (value) => Object.values(SIZES_ENUMS).includes(value)
    },
    variant: {
      type: String,
      default: VARIANTS_ENUMS.DEFAULT,
      validator: (value) => Object.values(VARIANTS_ENUMS).includes(value)
    }
  },
  setup(__props) {
    const props = __props;
    const computedClasses = computed(() => {
      return [
        "fh-spinner-icon",
        `fh-spinner-icon--${props.size}`,
        `fh-spinner-icon--${props.variant}`
      ];
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("span", _hoisted_1, [
        createVNode(FhVisuallyHidden, null, {
          default: withCtx(() => [
            _ctx.$slots.default ? renderSlot(_ctx.$slots, "default", { key: 0 }, void 0, true) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
              createTextVNode("Loading")
            ], 64))
          ]),
          _: 3
        }),
        createElementVNode("span", {
          class: normalizeClass(computedClasses.value),
          "aria-hidden": "true"
        }, null, 2)
      ]);
    };
  }
};
const FhSpinner = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-b52aeaef"]]);
export {
  FhSpinner as default
};
//# sourceMappingURL=FhSpinner.mjs.map
